export const states = [
    {
        key: 'CREATED',
        value: 'Creado'
    },
    {
        key: 'PENDING',
        value: 'Pendiente de Pago por cobrador/recibo'
    },
    {
        key: 'CHARGED',
        value: 'Cobrado'
    },
    {
        key: 'RETURNED',
        value: 'Devuelto'
    },
    {
        key: 'CANCELED',
        value: 'Anulado'
    },
    {
        key: 'CHARGE_BY_BANK',
        value: 'Cobrar por banco'
    }
];

export const periodicityMonths = [
    {
        key: 1,
        value: "Mensual",
    },
    {
        key: 3,
        value: "Trimestral",
    },
    {
        key: 6,
        value: "Semestral",
    },
    {
        key: 12,
        value: "Anual",
    },
];

export const paymentMethodNames = [
    {
        key: 'BANK',
        value: 'Banco'
    },
    {
        key: 'COLLECTOR',
        value: 'Cobrador'
    },
    {
        key: 'RECEIPT',
        value: 'Ingreso'
    },
]